import { createAccountDetailsStore } from '@/epos/vue/stores/modules/accountDetailsStore';
import { createAccountSearchStore } from '@/epos/vue/stores/modules/accountSearchStore';
import { createCartOffersStore } from '@/epos/vue/stores/modules/cartOffersStore';
import { createCartStore } from '@/epos/vue/stores/modules/cartStore';
import { createMembershipDetailsStore } from '@/epos/vue/stores/modules/membershipDetailsStore';
import { createOnlineQueueStore } from '@/epos/vue/stores/modules/onlineQueueStore';
import { createOrderDetailsStore } from '@/epos/vue/stores/modules/orderDetailsStore';
import { createOrderSearchStore } from './modules/orderSearchStore';
import { createPaymentStore } from '@/epos/vue/stores/modules/paymentStore';
import { createSellStore } from '@/epos/vue/stores/modules/sellStore';
import { createStore } from '@/vue/stores/store';
import { createSyncStore } from '@/vue/stores/modules/syncStore';
import { createTodayStore } from './modules/todayStore';

/**
 * Create a Vuex store instance to be used across epos.
 * This singleton instance is exported here so that it can be used in both the root Vue app, as well as sub-apps
 * for Vue pages inside Angular.
 *
 * @type {Store<{}>|boolean|?{builtAt: string, branch: string, commit: string}}
 */
export const eposStore = createStore({
    modules: {
        accountDetails: createAccountDetailsStore(),
        accountSearch: createAccountSearchStore(),
        cart: createCartStore(),
        cartOffers: createCartOffersStore(),
        membershipDetails: createMembershipDetailsStore(),
        onlineQueue: createOnlineQueueStore(),
        orderDetails: createOrderDetailsStore(),
        orderSearch: createOrderSearchStore(),
        payment: createPaymentStore(),
        sell: createSellStore(),
        sync: createSyncStore(),
        today: createTodayStore(),
    },
});
